import React from 'react';
import {
  AreaChart,
  Area,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  ResponsiveContainer,
} from 'recharts';
import _ from 'lodash';
import moment from 'moment';

const formatLabel = (value) => {
  if (!value) return '';
  const str = String(value);

  const m = moment(str, ['DD/MM/YYYY HH:mm:ss', 'DD/MM/YYYY HH:mm', 'DD-MM-YYYY', 'YYYY-MM-DD', moment.ISO_8601], true);
  if (m.isValid()) {
    return m.format('DD/MM');
  }

  const match = str.match(/(\d{1,2})[/\-.](\d{1,2})/);
  if (match) {
    return `${match[1]}/${match[2]}`;
  }

  return str;
};

// Tooltip personalizado que muestra un campo extra (ej. nombre de usuario)
const CustomTooltip = ({ active, payload, label, extraKey }) => {
  if (!active || !payload || !payload.length) return null;

  const data = payload[0].payload;
  const extraValue = extraKey && data[extraKey];

  return (
    <div style={{
      backgroundColor: '#fff',
      borderRadius: 8,
      padding: '8px 12px',
      boxShadow: '0 2px 8px rgba(0,0,0,0.15)',
      fontSize: 12,
    }}>
      <p style={{ margin: 0, color: '#999' }}>{label}</p>
      {extraValue && (
        <p style={{ margin: '4px 0 0', color: '#333', fontWeight: 600 }}>
          {extraKey}: {extraValue}
        </p>
      )}
      <p style={{ margin: '4px 0 0', color: payload[0].color, fontWeight: 500 }}>
        Préstamo{payload[0].value === 1 ? '' : 's'}: {payload[0].value}
      </p>
    </div>
  );
};

const lineChart = (props) => {
  const data = _.map(props.data, newData => {
    return {
      ...newData,
      trace_date: (/string/ig.test(typeof newData.trace_date) && newData.trace_date.length) - 1 === 19
        ? newData.trace_date
        : moment(newData.trace_date).format('DD-MM-YYYY')
    };
  });

  const strokeColor = props.lineColor || '#F5A623';
  const fillColor = props.fillColor || 'rgba(245, 166, 35, 0.15)';

  return (
    <ResponsiveContainer width="100%" height={props.height || 200}>
      <AreaChart
        data={data}
        margin={{ top: 10, right: 20, left: 0, bottom: 5 }}
      >
        <defs>
          <linearGradient id={`gradient-${props.dataKeyY}`} x1="0" y1="0" x2="0" y2="1">
            <stop offset="5%" stopColor={strokeColor} stopOpacity={0.3} />
            <stop offset="95%" stopColor={strokeColor} stopOpacity={0.02} />
          </linearGradient>
        </defs>
        <CartesianGrid strokeDasharray="3 3" vertical={false} stroke="#eee" />
        <XAxis
          dataKey={props.dataKeyX}
          tick={{ fontSize: 11, fill: '#999' }}
          axisLine={{ stroke: '#eee' }}
          tickLine={false}
          tickFormatter={formatLabel}
        />
        <YAxis
          tick={{ fontSize: 11, fill: '#999' }}
          axisLine={false}
          tickLine={false}
          allowDecimals={false}
        />
        {props.tooltipExtra ? (
          <Tooltip content={<CustomTooltip extraKey={props.tooltipExtra} />} />
        ) : (
          <Tooltip
            contentStyle={{
              borderRadius: 8,
              border: 'none',
              boxShadow: '0 2px 8px rgba(0,0,0,0.15)',
            }}
          />
        )}
        <Area
          type="monotone"
          dataKey={props.dataKeyY}
          stroke={strokeColor}
          strokeWidth={2}
          fill={`url(#gradient-${props.dataKeyY})`}
          dot={{ r: 3, fill: strokeColor, strokeWidth: 2, stroke: '#fff' }}
          activeDot={{ r: 5, fill: strokeColor, strokeWidth: 2, stroke: '#fff' }}
        />
        {props.showTwoLines && (
          <Area
            type="monotone"
            dataKey={props.dataKeyY2}
            stroke={props.lineColor2 || '#4BC0C0'}
            strokeWidth={2}
            fill="rgba(75, 192, 192, 0.1)"
            dot={{ r: 3 }}
            activeDot={{ r: 5 }}
          />
        )}
      </AreaChart>
    </ResponsiveContainer>
  );
};

export default lineChart;
